import React from 'react';
import styled from "styled-components";

const StyledButton = styled.button`
    min-height: 70px;
    font-weight: 500;
    font-size: 1.33rem;
    text-decoration: none;
    cursor: pointer;
    color: #fff;
    background-color: ${props => props.theme.codanColors.color};;
    padding: 0px;
    transition: all ease-in .15s;
    border: 0;
    width: 100%;
    margin: 1rem 0 21px 0;

    :hover {
        background-color: ${props => props.theme.codanColors.colorHover};
    }

    :focus {
        outline: 0;
        outline-color: initial;
        outline-style: initial;
        outline-width: 0px;
    }

    ${props => props.theme.mediaQueries.medium}{
        margin: 1rem 0 65px 0;
        font-size: 0.8rem;
        width: 320px;
    }
`

const Button = ({ type, onClick, text, name,  disabled}) => {
    return (
        <StyledButton 
            type={type}
            onClick={onClick}
            name={name}
            disabled={false}
        >
            {text}
        </StyledButton>
    )
}

export default Button;